<p-scrollPanel [style]="{ width: '100%', height: 'fit-content' }">
    <p-organizationChart [value]="data" selectionMode="single" [(selection)]="selectedNodes">
        <ng-template let-node pTemplate="person">
            <div class="p-2 text-center">
                <i [class]="node.data.user.icon" style="font-size: 2rem"></i>
                <div class="font-bold">{{ node.data.user.name |uppercase }} {{ node.data.user.lastName }}</div>
                <div>{{ node.data.label }}</div>
            </div>
        </ng-template>
    </p-organizationChart>
</p-scrollPanel>
<!-- <p-tree [value]="data" class="w-full md:w-30rem" selectionMode="single" (selectionChange)="onNodeSelected()" [(selection)]="selectedNodes">
    <ng-template let-node pTemplate="person">
        <i [class]="node.data.user.icon" style="font-size: 0.25 rem"></i>
        <label class="font-bold ml-1">{{ node.data.user.name }} ({{node.data.user.title}})</label>
    </ng-template>
</p-tree> -->
<p-dialog [draggable]="false" [closable]="false" [visible]="selectedNodes !== null" position="bottom">
    <ng-template pTemplate="header">
        <div class="flex justify-content-between flex-wrap gap-1 w-full">
            <div>
                <h3>{{selectedNodes?.data?.user?.name | uppercase}} {{selectedNodes?.data?.user?.lastName}}</h3>
                <h4 class="mb-0">{{selectedNodes?.data?.label}}</h4>
                <h4 class="mb-0">Telefono: {{selectedNodes?.data?.user?.phone}}</h4>
            </div>
            <p-button icon="pi pi-times" (onClick)="onDetailClosed()" [outlined]="true" severity="secondary"></p-button>
        </div>
    </ng-template>
    <ng-template pTemplate="message">
        <ng-container *ngIf="selectedNodes?.data?.roleDescription !== null">
            <div>
                <ol class="pl-4" type="a">
                    <ng-container *ngFor="let resp of selectedNodes?.data?.roleDescription?.split('\n')">
                        <li *ngIf="resp !== ''">
                            {{resp}}
                        </li>
                    </ng-container>
                </ol>
            </div>
        </ng-container>
    </ng-template>
    <ng-template pTemplate="footer">
    </ng-template>
</p-dialog>